import { render, staticRenderFns } from "./Decision.vue?vue&type=template&id=59d3e575&scoped=true"
import script from "./Decision.vue?vue&type=script&lang=js"
export * from "./Decision.vue?vue&type=script&lang=js"
import style0 from "./Decision.vue?vue&type=style&index=0&id=59d3e575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3e575",
  null
  
)

export default component.exports